import { InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { ExpirationTimeSelectValues } from '../types';

const ExpirationSelectDiv = styled.div`
    margin-top: 12px;
`;

const StyledSelect = styled(Select)`
    width: 200px;
`;

interface ExpirationSelectProps {
    expiresAt: string | null;
    handleChange: (event) => void;
}

const addMonths = (numOfMonths: number, date) => {
    date.setMonth(date.getMonth() + numOfMonths);
    return date;
};

const getExpirationTimeArray = () => {
    const addMonthArr = [1, 3, 6, 12];
    const expirationTimesArr: any[] = [];
    addMonthArr.forEach((numberOfMonths) => {
        const currentTime = new Date();
        const laterDate = addMonths(numberOfMonths, currentTime);
        laterDate.setUTCHours(0, 0, 0, 0);
        expirationTimesArr.push(laterDate.toISOString());
    });
    expirationTimesArr.push('no-expiration');
    return expirationTimesArr;
};

const ExpirationSelect: React.FC<ExpirationSelectProps> = ({ expiresAt, handleChange }) => {
    const { t } = useTranslation('admin_settings');
    const { ONE_MONTH, THREE_MONTHS, SIX_MONTHS, TWELVE_MONTHS, NO_EXPIRATION } = ExpirationTimeSelectValues;
    const expirationTimes = getExpirationTimeArray();

    return (
        <ExpirationSelectDiv>
            <InputLabel>{t('api-keys.form-expiresAt')}</InputLabel>
            <StyledSelect
                name='expires_at'
                value={expiresAt || 'no-expiration'}
                size="small"
                onChange={handleChange}
            >
                <MenuItem
                    value={expirationTimes[ONE_MONTH]}
                    key={0}
                >
                    {t('api-keys.1-month')}
                </MenuItem>
                <MenuItem
                    value={expirationTimes[THREE_MONTHS]}
                    key={1}
                >
                    {t('api-keys.3-months')}
                </MenuItem>
                <MenuItem
                    value={expirationTimes[SIX_MONTHS]}
                    key={2}
                >
                    {t('api-keys.6-months')}
                </MenuItem>
                <MenuItem
                    value={expirationTimes[TWELVE_MONTHS]}
                    key={3}
                >
                    {t('api-keys.12-months')}
                </MenuItem>
                <MenuItem
                    value={expirationTimes[NO_EXPIRATION]}
                    key={4}
                >
                    {t('api-keys.no-expiration')}
                </MenuItem>
            </StyledSelect>
        </ExpirationSelectDiv>
    );
};

export default ExpirationSelect;
